var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Box } from "@mui/material";
import { COLORS } from "../../../../../constants/colors";
var Logo = function (_a) {
    var logoUrl = _a.logoUrl, _b = _a.diameter, diameter = _b === void 0 ? 44 : _b, blankSpace = _a.blankSpace;
    if (!logoUrl) {
        if (!blankSpace) {
            return null;
        }
        return _jsx(Box, { padding: blankSpace });
    }
    return (_jsx(Stack, __assign({ sx: {
            backgroundColor: COLORS.WHITE,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            overflow: "hidden",
            boxShadow: "0 1px 5px 0 rgb(0 0 0 / 20%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 2px 2px 0 rgb(0 0 0 / 14%)",
            height: diameter,
            width: diameter,
            minWidth: diameter,
            zIndex: 1,
        } }, { children: _jsx("img", { src: logoUrl, style: { height: "100%", width: "100%", objectFit: "contain" } }) })));
};
export default Logo;
